export default function SectionWrapper({ title ,subTitle , children }) {
  return (
    <div className="w-full border border-[#f8f6f6] bg-white rounded-2xl shadow-[0_0_10px_rgba(0,0,0,0.06)] pb-6 pt-4 flex flex-col">
      <div className="border-b border-[#d3d4d4]  px-3 sm:px-4 md:px-6 lg:px-8 pb-2 mb-6">
         <h2 className="text-base md:text-lg lgs:text-xl font-semibold ">
         {title}{" "}
          <span className="text-[#3587B8]">{subTitle}</span>
        </h2>
      </div>
      {children}
    </div>
  );
}
